const isNumberOrEmpty = (value) => {
  return value === undefined || !isNaN(Number(value));
};

const ExtraDetail = ({ type, extra, setExtra }) => {
  const handleChangeDistance = (e) => {
    if (isNumberOrEmpty(e.target.value)) {
      setExtra((prev) => ({
        ...prev,
        distance: e.target.value,
      }));
    }
  };

  const handleChangeSteps = (e) => {
    if (isNumberOrEmpty(e.target.value)) {
      setExtra((prev) => ({
        ...prev,
        steps: e.target.value,
      }));
    }
  };

  const handleChangeCycle = (e) => {
    if (isNumberOrEmpty(e.target.value)) {
      setExtra((prev) => ({
        ...prev,
        cycle: e.target.value,
      }));
    }
  };

  const handleChangeRestCycle = (e) => {
    if (isNumberOrEmpty(e.target.value)) {
      setExtra((prev) => ({
        ...prev,
        restCycle: e.target.value,
      }));
    }
  };

  const handleChangeRestExercise = (e) => {
    if (isNumberOrEmpty(e.target.value)) {
      setExtra((prev) => ({
        ...prev,
        restExercise: e.target.value,
      }));
    }
  };

  if (type === 'CARDIO') {
    return (
      <>
        <div className='flex items-center justify-between gap-2 mb-4'>
          <label className='text-white font-semibold'>Distance</label>
          <div className='text-white flex items-center gap-2'>
            <div className='flex items-center gap-2'>
              <input
                type='number'
                name='distance'
                value={extra.distance}
                onChange={handleChangeDistance}
                className='rounded-full px-2 py-1 bg-tertiary  text-white max-w-20 text-center'
              />
              <span className='min-w-10 text-right'>km</span>
            </div>
          </div>
        </div>
        <div className='flex items-center justify-between gap-2 mb-4'>
          <label className='text-white font-semibold'>Steps</label>
          <div className='text-white flex items-center gap-2'>
            <div className='flex items-center gap-2'>
              <input
                type='number'
                name='steps'
                value={extra.steps}
                onChange={handleChangeSteps}
                className='rounded-full px-2 py-1 bg-tertiary  text-white max-w-20 text-center'
              />
              <span className='min-w-10 text-right'>steps</span>
            </div>
          </div>
        </div>
      </>
    );
  }
  if (type === 'HIIT') {
    return (
      <>
        <div className='flex items-center justify-between gap-2 mb-4'>
          <label className='text-white font-semibold'>Cycles</label>
          <div className='text-white flex items-center gap-2'>
            <div className='flex items-center gap-2'>
              <select
                name='cycle'
                value={extra.cycle}
                onChange={handleChangeCycle}
                className='rounded-full px-2 py-1 bg-tertiary  text-white max-w-20 text-center'
              >
                {Array.from({ length: 21 }, (_, i) => (
                  <option
                    key={i}
                    value={i}
                  >
                    {i}
                  </option>
                ))}
              </select>
              <span className='min-w-11 text-right'>cycles</span>
            </div>
          </div>
        </div>
        <div className='flex items-center justify-between gap-2 mb-4'>
          <label className='text-white font-semibold'>
            Rest between cycles
          </label>
          <div className='text-white flex items-center gap-2'>
            <div className='flex items-center gap-2'>
              <select
                name='restCycle'
                value={extra.restCycle}
                onChange={handleChangeRestCycle}
                className='rounded-full px-2 py-1 bg-tertiary  text-white max-w-20 text-center'
              >
                {Array.from({ length: 121 }, (_, i) => (
                  <option
                    key={i}
                    value={i * 5}
                  >
                    {i * 5}
                  </option>
                ))}
              </select>
              <span className='min-w-11 text-right'>sec</span>
            </div>
          </div>
        </div>
        <div className='flex items-center justify-between gap-2 mb-4'>
          <label className='text-white font-semibold'>
            Rest between exercises
          </label>
          <div className='text-white flex items-center gap-2'>
            <div className='flex items-center gap-2'>
              <select
                name='restExercise'
                value={extra.restExercise}
                onChange={handleChangeRestExercise}
                className='rounded-full px-2 py-1 bg-tertiary  text-white max-w-20 text-center'
              >
                {Array.from({ length: 121 }, (_, i) => (
                  <option
                    key={i}
                    value={i * 5}
                  >
                    {i * 5}
                  </option>
                ))}
              </select>
              <span className='min-w-11 text-right'>sec</span>
            </div>
          </div>
        </div>
      </>
    );
  }

  return null;
};

export default ExtraDetail;
